import React from "react";
import { Link } from "react-router-dom";

// Matches a URL starting at the current position: http(s):// or bare www.
const URL_RE = /^(https?:\/\/[^\s]+|www\.[^\s]+)/i;
// Trailing punctuation that commonly sits next to a URL in prose and isn't part of it.
const TRAIL = /[.,!?;:)\]}'"]+$/;

function matchUrl(text, i) {
  const m = text.slice(i).match(URL_RE);
  if (!m) return null;
  let url = m[0];
  const t = url.match(TRAIL);
  if (t) url = url.slice(0, url.length - t[0].length);
  return url || null;
}

// Renders body text with @Mentions linkified to the member's profile and any
// typed/pasted URLs auto-detected as tappable links (open in a new tab).
export default function MentionText({ text, mentions = [], className = "" }) {
  if (!text) return null;
  const names = (mentions || [])
    .filter((m) => m && m.full_name)
    .map((m) => ({ name: m.full_name, id: m.user_id }))
    .sort((a, b) => b.name.length - a.name.length);

  const nodes = [];
  let buf = "";
  let i = 0;
  let key = 0;
  const flush = () => { if (buf) { nodes.push(<React.Fragment key={key++}>{buf}</React.Fragment>); buf = ""; } };
  while (i < text.length) {
    if (text[i] === "@") {
      const m = names.find((n) => text.startsWith("@" + n.name, i));
      if (m) {
        flush();
        nodes.push(
          <Link key={key++} to={`/member/${m.id}`} data-testid={`mention-link-${m.id}`} className="text-brand font-medium hover:underline">@{m.name}</Link>
        );
        i += 1 + m.name.length;
        continue;
      }
    }
    const c = text[i];
    if (c === "h" || c === "H" || c === "w" || c === "W") {
      const url = matchUrl(text, i);
      if (url) {
        flush();
        const href = /^https?:\/\//i.test(url) ? url : `https://${url}`;
        nodes.push(
          <a key={key++} href={href} target="_blank" rel="noopener noreferrer"
            data-testid="comment-link" onClick={(e) => e.stopPropagation()}
            className="text-brand font-medium underline break-all">{url}</a>
        );
        i += url.length;
        continue;
      }
    }
    buf += c;
    i++;
  }
  flush();
  return <span className={className} style={{ whiteSpace: "pre-wrap" }}>{nodes}</span>;
}
